
import { mapGetters, mapActions } from 'vuex';
import steps from '@/component/steps.vue';
import pageHead from '@/component/page-header.vue';
import Toast from 'vux/src/components/toast/index.vue'

export default {
components: {
steps,
pageHead,
Toast
},
name: 'selfRatingGrade',
data() {
return {
showToast: false,
stepsArr: [
{ label: '信息确认', active: false },
{ label: '填写自评等次', active: true },
{ label: '发起考核', active: false }
],
pullDown: false,
selectValue: '',
selfRatingOps: [
{ label: '称职', value: '称职' },
{ label: '基本称职', value: '基本称职' },
{ label: '不称职', value: '不称职' },
{ label: '暂缓考核', value: '暂缓考核' },
{ label: '新领证不评定等次', value: '新领证不评定等次' }
],
timeId: ''
};
},
methods: {
...mapActions([]),
selecked(item) {
this.selectValue = item.label;
this.pullDown = false;
},
prevSteps() {
this.$router.push({
path: '/annual-assess'
});
},
displayMsg() {
this.showToast = true;
}
},
watch: {},
computed: {
...mapGetters([])
},
created() {},
mounted() {
let elem = document.querySelector('#vux_view_box_body');
setTimeout(() => {
elem.style.paddingBottom = '0';
}, 10);
}
};
